import { render, staticRenderFns } from "./AlfRelatedTwo.vue?vue&type=template&id=3be69cbf&"
import script from "./AlfRelatedTwo.vue?vue&type=script&lang=js&"
export * from "./AlfRelatedTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3be69cbf')) {
      api.createRecord('3be69cbf', component.options)
    } else {
      api.reload('3be69cbf', component.options)
    }
    module.hot.accept("./AlfRelatedTwo.vue?vue&type=template&id=3be69cbf&", function () {
      api.rerender('3be69cbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/product/related/AlfRelatedTwo.vue"
export default component.exports